import { AuthErrorCode } from '@/enums/AuthErrorCode';

import { AuthApiError } from './api';

const AUTH_ERROR_CODES = new Set<string>(Object.values(AuthErrorCode));
const FALLBACK_CODE = AuthErrorCode.RequestFailed;

const coerceAuthErrorCode = (code: unknown): AuthErrorCode =>
    typeof code === 'string' && AUTH_ERROR_CODES.has(code) ? (code as AuthErrorCode) : FALLBACK_CODE;

export const getAuthErrorCode = (error: unknown): AuthErrorCode => {
    if (error instanceof AuthApiError) {
        return coerceAuthErrorCode(error.code);
    }

    if (!error || typeof error !== 'object' || !('code' in error)) {
        return FALLBACK_CODE;
    }

    const code = (error as { code?: unknown }).code;

    return coerceAuthErrorCode(code);
};

export const resolveAuthErrorCode = ({ error, isRegistrationFlow = false }: { error: unknown; isRegistrationFlow?: boolean }): AuthErrorCode => {
    const code = getAuthErrorCode(error);

    return isRegistrationFlow && code === AuthErrorCode.UserNotFound ? AuthErrorCode.RegistrationUnavailable : code;
};
